import { activateUserAccount } from "./activateUserAccount";
import { loginUser } from "./login";
import { passwordReset } from "./passwordReset";
import { passwordResetRequest } from "./passwordResetRequest";
import { refreshAccessToken } from "./refreshAccessToken";
import { verifyUser } from "./verifyUser";
import { verifyPasswordResetRequest } from "./verifyPasswordResetRequest";
import { changePassword } from "./changePassword";

export const AuthApi = {
  loginUser,
  verifyUser,
  activateUserAccount,
  passwordReset,
  verifyPasswordResetRequest,
  passwordResetRequest,
  refreshAccessToken,
  changePassword

};
